// js for the strawberry page
// Product slider with thumbs
let productsThumbs = new Swiper(".product_thumb-slider", {
    spaceBetween: 5,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
        751: { slidesPerView: 4, spaceBetween: 10,},
        990: { slidesPerView: 5, spaceBetween: 10,},
    }
});
// thumbs
let productSlider = new Swiper(".product_main-slider", {
    observer: true,
    observeParents: true,
    navigation: {
        nextEl: ".product_media-wrapper .swiper-button-next",
        prevEl: ".product_media-wrapper .swiper-button-prev",
    },
    thumbs: {
        swiper: productsThumbs, 
    },
});
// Bundle data
$(document).ready(function() {


    $('.bundleData_btn').on('click', function() {
        $(this).addClass('active');

        $('.bundleData_btn').not(this).removeClass('active');
        if($(this).hasClass('subscriptionMine')) {
             $('#buy_subscription_id').trigger('click');
             $('.offer_listing').removeClass('hide');
             $('.sellingplan_bundlebar').removeClass('hide');
             $('.bundle_pricing').removeClass('hide');
             $('.onetime_pricing').addClass('hide');
             $('.onetime_pricing_sticky').addClass('hide');
             $('.bundle_pricing_sticky').removeClass('hide');
        } else {
             $('#buying_onetime_id').trigger('click');
             $('.offer_listing').addClass('hide');
             $('.bundle_pricing').addClass('hide');
             $('.onetime_pricing').removeClass('hide');
             $('.offer_listing').addClass('hide');
             $('.onetime_pricing_sticky').removeClass('hide');
             $('.bundle_pricing_sticky').addClass('hide');  
        }
    });

    // update buttons
    $('.bundles_bar-label').on('click', function () {
        const imgUrl = $(this).data('variantimg');
        const $this = $(this);
        const packValue = String($this.data('value')).trim();
        const days = String($this.data('sub')).trim();
        const pricetextonetime = $(this).find('.onetime_pricing').html();
        const pricetextsubs    = $(this).find('.bundle_pricing').html();
        $('.onetime_pricing_sticky').html(pricetextonetime);
        $('.bundle_pricing_sticky').html(pricetextsubs);
        //console.log(pricetextonetime);
        //console.log(pricetextsubs);
        // push data to main images
        $('.mainimage_load[data-imageindex="1"]').attr('src', imgUrl);
        // Select product variant by text
        const $variantSelect = $('.product-form__variants');
        $variantSelect.find('option').each(function () {
            if ($(this).text().trim() === packValue) {
                this.selected = true;
                return false;
            }
        });
        $variantSelect.trigger('change');
        // Select selling plan by option
        const $sellingSelect = $('.buying_SelectOpt');
        $sellingSelect.find('option').each(function () {
            if ($(this).text().trim() === days) {
                this.selected = true;
                return false;
            }
        });
        $sellingSelect.trigger('change');
    });
});
// Accordions
$(document).on("click", ".accordion_header", function () {
    $(this).parents(".accordion_wrap .accordion").siblings().removeClass("active").find(".accordion_content").slideUp();
    $(this).parent().toggleClass("active");
    $(this).next(".accordion_content").slideToggle(200);
});
// Quantity selector 
$(document).ready(function () {
    function updateButtons($wrap) {
        let value = parseInt($wrap.find(".quantity_input").val()) || 1;
        let $minusBtn = $wrap.find('.quantity_btn[data-type="minus"]');
        if (value <= 1) {
            $minusBtn.prop("disabled", true);
        } else {
            $minusBtn.prop("disabled", false);
        }
    }
    $(document).on("click", ".quantity_btn", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $wrap = $btn.closest(".quick-atc-form");
    const $input = $wrap.find(".quantity_input");
    let qty = parseInt($input.val(), 10) || 1;
    const type = $btn.data("type");
    if (type === "plus" && qty < 5) qty++;
    if (type === "minus" && qty > 1) qty--;
    // 🔥 FORCE SYNC (this is the key)
    $input
        .val(qty)
        .attr("value", qty)
        .trigger("input")
        .trigger("change");

    // Optional: lock value so theme JS can’t overwrite
    setTimeout(() => {
        $input.val(qty).attr("value", qty);
    }, 0);
    });
    $(".quantity_input").on("input", function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value === "" || parseInt(this.value) < 1) {
            this.value = 1;
        }
        updateButtons($(this).closest(".quantity_wrap"));
    });
    $(".quantity_wrap").each(function () {
        updateButtons($(this));
    });
    });
// Customer slider
$(document).ready(function () {
    if ($(window).width() < 751) {
        $('.my-customer-swiper').each(function () {
            const $swiper = $(this);
            const $nav = $swiper.find('.custom-nav');
            const $prev = $nav.find('.custom-prev')[0];
            const $next = $nav.find('.custom-next')[0];
            const $current = $nav.find('.current');
            const $total = $nav.find('.total');
            const swiper = new Swiper(this, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    nextEl: $next,
                    prevEl: $prev,
                }
            });
            $total.text(swiper.slides.length);
            swiper.on('slideChange', function () {
                $current.text(swiper.realIndex + 1);
            });
        });
    }
});
// Formula slider
$(document).ready(function () {
    if ($(window).width() <= 750) {
        $('.formula-slider').each(function () {
            const $swiper = $(this);
            const $nav = $swiper.find('.custom-nav');
            const $prev = $nav.find('.custom-prev')[0];
            const $next = $nav.find('.custom-next')[0];
            const $current = $nav.find('.current');
            const $total = $nav.find('.total');
            const swiper = new Swiper(this, {
                slidesPerView: 1,
                navigation: {
                    nextEl: $next,
                    prevEl: $prev,
                }
            });
            $total.text(swiper.slides.length);
            swiper.on('slideChange', function () {
                $current.text(swiper.realIndex + 1);
            });
        });
    }
});

// Bundle
$(document).ready(function () {
   $('input[name="id"]').on('change', function () {
        if ($(this).data('sub') === 30) {
            $('.autoShip_plan').text('Autoships Every Month');
        } 
        else if ($(this).data('sub') === 60) {
            $('.autoShip_plan').text('Autoships Every 2 Months');
        } 
        else if ($(this).data('sub') === 90) {
            $('.autoShip_plan').text('Autoships Every 3 Months');
        }
    });
});


// on scroll sticky btn desktop and mobile view
const mediaQueryList = window.matchMedia('(max-width: 768px)');
function screenTest(e) {
  const customHeight = e.matches ? 1400 : 900;
  $(window).off('scroll.sticky').on('scroll.sticky', function () {
    const stickyWrapOffset = $('.product_detail').offset().top + customHeight;
    $('.sticky_atc-bar').toggleClass(
      'hide',
      $(window).scrollTop() < stickyWrapOffset
    );
  });
}
screenTest(mediaQueryList);
mediaQueryList.addEventListener('change', screenTest);

// on scroll sticky btn desktop and mobile view end


$(document).on('click', 'button#trigger_main', function () {
    $('#addToCart').trigger('click');
    //alert('clicked');
});
